const component = document.querySelector('.o-hero-mini')

if (component) {
  const classes = {
    mobile: 'mobile',
    menu: '--menu-open-mini',
    popup: '--popup-open',
  }
  const buttonCarret = component.querySelector('.open-menu-mini')
  const buttonTitle = component.querySelector('.menu .title')
  const iconTitle = buttonCarret.querySelector('svg use')
  const iconPopup = buttonTitle.querySelector('svg use')

  const openPopup = () => {
    component.classList.add(classes.popup)
    iconPopup.setAttribute('xlink:href', '#icon-minus')
  }

  const closePopup = () => {
    component.classList.remove(classes.popup)
    iconPopup.setAttribute('xlink:href', '#icon-plus')
  }

  const openMenuMini = () => {
    //component.classList.add(classes.popup)
    iconTitle.setAttribute('xlink:href', '#icon-minus')
  }

  const closeMenuMini = () => {
    //component.classList.remove(classes.popup)
    iconTitle.setAttribute('xlink:href', '#icon-caret')
  }

  const hideBot = () => {
    const launcher = document.querySelector('#botnation-chatbox-launcher-container');
    if (launcher) {
      launcher.style.display = 'none';
    }
    const chatbox = document.querySelector('#botnation-chatbox-container');
    if (chatbox) {
      chatbox.style.display = 'none';
    }
  }

  const showBot = () => {
    const launcher = document.querySelector('#botnation-chatbox-launcher-container');
    if (launcher) {
      launcher.style.display = 'block';
    }
    const chatbox = document.querySelector('#botnation-chatbox-container');
    if (chatbox) {
      chatbox.style.display = 'block';
    }
  }

  buttonCarret.addEventListener('click', () => {
    if (!component.classList.contains(classes.menu)) {
      component.classList.add(classes.menu)
      openMenuMini();
      console.log('caret : hide bot');
      hideBot();
    } else {
      component.classList.remove(classes.menu)
      closeMenuMini();
      closePopup();
      console.log('caret : show bot');
      showBot();
    }
  })

  buttonTitle.addEventListener('click', () => {
    component.classList.toggle(classes.popup)
    if (component.classList.contains(classes.popup)) {
      openPopup()
      console.log('title : hide bot');
      hideBot();
    } else {
      closePopup()
      if (!component.classList.contains(classes.menu)) {
        console.log('title : show bot desktop');
        showBot();
      }
      else {
        hideBot();
      }
    }
  })
}
